module.exports = __webpack_public_path__ + "static/erp-slider1-0c45c404669d7aa3bc79faa1e6545ff6.jpeg";